import { parseEntityRef, DEFAULT_NAMESPACE } from '@backstage/catalog-model';

class ReadmeClient {
  discoveryApi;
  fetchApi;
  identityApi;
  constructor(options) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
    this.identityApi = options.identityApi;
  }
  async getReadmeContent(entityRef) {
    const { token } = await this.identityApi.getCredentials();
    const baseUrl = await this.discoveryApi.getBaseUrl("readme");
    const { kind, name, namespace } = parseEntityRef(entityRef, {
      defaultNamespace: DEFAULT_NAMESPACE
    });
    const resp = await this.fetchApi.fetch(
      `${baseUrl}/${kind}/${namespace}/${name}`,
      {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    if (resp.ok) {
      return [
        await resp.text(),
        resp.headers.get("Content-Type") || "text/plain"
      ];
    }
    if (resp.status === 404) {
      throw new Error("404");
    }
    throw new Error(`${resp.status}: ${resp.statusText}`);
  }
}

export { ReadmeClient };
//# sourceMappingURL=ReadmeClient.esm.js.map
